





































import Vue from 'vue';

import { Post } from './settings/admin/posts.vue';

export default Vue.extend({
  name: 'post',
  // mounted() {},
  props: {
    post: Post,
  },
  methods: {
    getTitle(): string {
      if (this.$props.Title === '') {
        return this.$props.ID;
      }
      return this.$props.Title;
    },
  },
  computed: {
    getDate(): string {
      if (!(this.post.Date instanceof Date)) {
        this.post.Date = new Date(this.post.Date);
      }

      const local = localStorage.getItem('lang') as string;
      return this.post.Date.toLocaleDateString(local);
    },
  },
});

